import { Routes, Route } from 'react-router-dom';
import { AppProvider } from './FirebaseAppContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Overview from './pages/Overview';
import Cars from './pages/Cars';
import CarDetail from './pages/CarDetail';
import CarForm from './pages/CarForm';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import CustomerForm from './pages/CustomerForm';
import Rentals from './pages/Rentals';
import RentalDetail from './pages/RentalDetail';
import RentalForm from './pages/RentalForm';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import ServiceForm from './pages/ServiceForm';
import Help from './pages/Help';
import ForgotPassword from './pages/ForgotPassword';
import VerifyEmail from './pages/VerifyEmail';
import Landing from './pages/Landing';
import SetupOrganization from './pages/SetupOrganization';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

/**
 * Public routes - accessible without authentication
 */
export function PublicRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/setup-organization" element={<SetupOrganization />} />
    </Routes>
  );
}

/**
 * Protected routes - require authentication
 */
export function ProtectedRoutes() {
  return (
    <ProtectedRoute>
      <AppProvider>
        <Layout>
          <Routes>
            <Route path="/overview" element={<Overview />} />
            <Route path="/cars" element={<Cars />} />
            <Route path="/cars/new" element={<CarForm />} />
            <Route path="/cars/:carId" element={<CarDetail />} />
            <Route path="/cars/:carId/edit" element={<CarForm />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/new" element={<CustomerForm />} />
            <Route path="/customers/:customerId" element={<CustomerDetail />} />
            <Route path="/customers/:customerId/edit" element={<CustomerForm />} />
            <Route path="/rentals" element={<Rentals />} />
            <Route path="/rentals/new" element={<RentalForm />} />
            <Route path="/rentals/:rentalId" element={<RentalDetail />} />
            <Route path="/rentals/:rentalId/edit" element={<RentalForm />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/new" element={<ServiceForm />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/services/:serviceId/edit" element={<ServiceForm />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/help" element={<Help />} />
            <Route path="/calendar" element={<Calendar />} />
          </Routes>
        </Layout>
      </AppProvider>
    </ProtectedRoute>
  );
}

/**
 * All application routes
 */
export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/setup-organization" element={<SetupOrganization />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppProvider>
              <Layout>
                <Routes>
                  <Route path="/overview" element={<Overview />} />
                  <Route path="/cars" element={<Cars />} />
                  <Route path="/cars/new" element={<CarForm />} />
                  <Route path="/cars/:carId" element={<CarDetail />} />
                  <Route path="/cars/:carId/edit" element={<CarForm />} />
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/customers/new" element={<CustomerForm />} />
                  <Route path="/customers/:customerId" element={<CustomerDetail />} />
                  <Route path="/customers/:customerId/edit" element={<CustomerForm />} />
                  <Route path="/rentals" element={<Rentals />} />
                  <Route path="/rentals/new" element={<RentalForm />} />
                  <Route path="/rentals/:rentalId" element={<RentalDetail />} />
                  <Route path="/rentals/:rentalId/edit" element={<RentalForm />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/new" element={<ServiceForm />} />
                  <Route path="/services/:serviceId" element={<ServiceDetail />} />
                  <Route path="/services/:serviceId/edit" element={<ServiceForm />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/help" element={<Help />} />
                  <Route path="/calendar" element={<Calendar />} />
                </Routes>
              </Layout>
            </AppProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

